import store from "app/redux/store/store"
import globalMU from "globalMU"
import * as R from "ramda"
import { Ambiente } from "./Ambiente"

export const obterAmbientesPelosItens = () : Ambiente[] => {
    return (store.getState().orcamento.ItensOrcamento ?? []).reduce((ambientes,item) => {
        return globalMU.isNullOrEmpty(item.Ambiente) ? ambientes : 
            ambientes.find(a => a.nome == item.Ambiente) != null ? ambientes : 
            R.append({
                nome: item.Ambiente,
                cor: store.getState().corPorAmbiente[item.Ambiente]
            } as Ambiente, ambientes)

    },[] as Ambiente[])
}